/**
 * Corps de `POST /api/v1/{slug}/book` à partir du formulaire.
 *
 * Les champs facultatifs laissés vides sont omis : l'API refuse une chaîne
 * vide pour `phone` (min 3 caractères) et ne l'accepte que si le tenant le
 * collecte. Même règle pour `message`.
 */
export function buildBookingPayload(form, slot, config) {
  const payload = {
    start: slot.start,
    end: slot.end,
    name: form.name.trim(),
    email: form.email.trim()
  };

  if (config.collectPhone) {
    const phone = form.phone.trim();
    if (phone) {
      payload.phone = phone;
    }
  }

  if (config.collectMessage) {
    const message = form.message.trim();
    if (message) {
      payload.message = message;
    }
  }

  return payload;
}
